import styled from 'styled-components'

export const StyledMainBuybackContainer = styled.div``

export const StyledLonBuybackHeadContainer = styled.section`
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    h1 {
      font-weight: bold;
      font-size: 25px;
      color: ${({ theme }) => theme.colors.textContent};
      margin: 0;
    }
  }
  .description {
    color: #9aa3ae;
    margin-top: 10px;
    font-size: 14px;
    margin-left: 48px;
  }
  @media screen and (max-width: 640px) {
    margin-top: 0;
    .header {
      .title {
        font-size: 19px;
      }
    }
    .description {
      margin-left: 0;
      font-size: 13px;
    }
  }
`

export const StyledBuybackWrap = styled.div`
  background-color: ${({ theme }) => theme.colors.bgBase};
  h4.title {
    color: ${({ theme }) => theme.colors.textTertiary} !important;
    margin-bottom: 15px;
  }
  @media screen and (max-width: 640px) {
    h4.title {
      color: ${({ theme }) => theme.colors.textContent} !important;
      font-size: 15px !important;
    }
    .data-container {
      padding: 16px 20px 14px !important;
    }
  }
`

export const StyledBuybackContentWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 120px 0 0;
  flex: 1;
  @media screen and (max-width: 640px) {
    padding: 48px 15px 35px;
    width: 100%;
  }
`
